







import { Component, Vue } from 'vue-property-decorator';
import { MapGetters } from '@/utils/vuexHelpers';

@Component
@MapGetters('app', ['routeLoading'])
export default class App extends Vue {}
